import { axiosInstance } from "./AxiosInstance";

export async function getMedications(patientId) {
  return axiosInstance
    .get(`/api/PatientMedications?patientId=${patientId}`)
    .then(function (response) {
      //debugger;
      return response;
    })
    .catch(function (error) {
      return error;
    });
}
